import { render, staticRenderFns } from "./TrailerForm.vue?vue&type=template&id=71dd949e&scoped=true&"
import script from "./TrailerForm.vue?vue&type=script&lang=js&"
export * from "./TrailerForm.vue?vue&type=script&lang=js&"
import style0 from "./TrailerForm.vue?vue&type=style&index=0&id=71dd949e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd949e",
  null
  
)

export default component.exports